import { createSlice } from "@reduxjs/toolkit";
import {
  getAllPosts,
  getTop10Posts,
  getTheLatestPosts,
  getFBPosts,
  getTWPosts,
  getNWPosts,
  getIGPosts,
  addNewPost,
  updatePost,
  deletePost,
  getStatsPosts,
  getTotalStatsPosts,
  getTotalLikesCounts,
  getTotalStatsQueryPosts,
  getStatsFBPosts,
  getStatsTWPosts,
  getStatsNWPosts,
  getStatsIGPosts,
  getRPTStatsPosts,
  getRPTStatsFBPosts,
  getRPTStatsTWPosts,
  getRPTStatsNWPosts,
  getRPTStatsIGPosts,
  getRPTTotalStatsPosts,
  getRPTPosts,
  getWordCloud,
  getMonthlyTrend,
} from "./thunk";

export const initialState = {
  top10posts: [],
  thelatestposts: [],
  totalstatsposts: [],
  rpttotalstatsposts: [],
  totalstatsQueryposts: [],
  totallikescounts: [],

  allposts: [],
  posts: [],
  fbposts: [],
  twposts: [],
  nwposts: [],
  igposts: [],
  rptposts: [],

  statsposts: [],
  rptstatsposts: [],
  statsFBposts: [],
  statsTWposts: [],
  statsNWposts: [],
  statsIGposts: [],

  rptstatFBsposts: [],
  rptstatTWsposts: [],
  rptstatNWsposts: [],
  rptstatIGsposts: [],
  wordcloud: [],
  monthlyTrend: [],

  allerror: {},
  top10error: {},
  thelatesterror: {},
  fberror: {},
  twerror: {},
  nwerror: {},
  igerror: {},
  rpterror: {},
  statserror: {},
  totalstatserror: {},
  rptstatserror: {},
  rptstatsFBerror: {},
  rptstatsTWerror: {},
  rptstatsNWerror: {},
  rptstatsIGerror: {},
  rpttotalstatserror: {},
  totalstatsQueryerror: {},
  totallikescountserror: {},
  wordclouderror: {},

  statFBserror: {},
  statTWserror: {},
  statNWserror: {},
  statIGserror: {},

  top10postsLoading: {},
  thelatestpostsLoading: {},
  rptpostsLoading: {},
  fbpostsLoading: {},
  twpostsLoading: {},
  nwpostsLoading: {},
  igpostsLoading: {},
  statspostsLoading: {},
  rptstatspostsLoading: {},
  rpttotalstatspostsLoading: [],

  isStatsPostLoading: false,
  isStatsPostSuccess: false,

  isTotalStatsPostSuccess: false,
  isTotalStatsPostLoading: false,

  isTotalTotalLikesCountsSuccess: false,
  isTotalTotalLikesCountsLoading: false,

  isTop10PostSuccess: false,
  isTop10PostLoading: false,

  isFBPostLoading: false,
  isFBPostSuccess: false,

  isTWPostLoading: false,
  isTWPostSuccess: false,

  isNWPostLoading: false,
  isNWPostSuccess: false,

  isIGPostLoading: false,
  isIGPostSuccess: false,

  isTotalStatsQueryPostLoading: false,
  isTotalStatsQueryPostSuccess: false,

  isAllPostLoading: false,
  isAllPostSuccess: false,

  isWordCloudLoading: false,
  isWordCloudSuccess: false,
};

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getALLPosts/ ]=================================
    builder.addCase(getAllPosts.pending, (state) => {
      state.isAllPostLoading = true;
      state.isAllPostSuccess = false;
      state.allerror = null;
    });
    builder.addCase(getAllPosts.fulfilled, (state, action) => {
      state.isAllPostLoading = false;
      state.isAllPostSuccess = true;
      state.allposts = action.payload;
    });
    builder.addCase(getAllPosts.rejected, (state, action) => {
      state.isAllPostLoading = false;
      state.isAllPostSuccess = false;
      state.allerror = action.error.message;
    });
    //====================================================================================

    //The latest posts
    builder.addCase(getTheLatestPosts.fulfilled, (state, action) => {
      state.thelatestposts = action.payload;
      state.isTheLatestPostFail = false;
      state.isTheLatestPostSuccess = true;
      state.top10postsLoading = false;
    });

    builder.addCase(getTheLatestPosts.rejected, (state, action) => {
      state.thelatesterror = action.payload.thelatesterror || null;
      state.isTheLatestPostFail = true;
      state.isTheLatestPostSuccess = false;
      top10postsLoading = true;
    });

    //==================================[ /Top posts/ ]=======================================
    builder.addCase(getTop10Posts.pending, (state) => {
      state.isTop10PostLoading = true;
      state.isTop10PostSuccess = false;
      state.top10error = null;
    });
    builder.addCase(getTop10Posts.fulfilled, (state, action) => {
      state.isTop10PostLoading = false;
      state.isTop10PostSuccess = true;
      state.top10posts = action.payload;
    });
    builder.addCase(getTop10Posts.rejected, (state, action) => {
      state.isTop10PostLoading = false;
      state.isTop10PostSuccess = false;
      state.top10error = action.error.message;
    });

    //==================================[ /statstotal/ ]=======================================
    builder.addCase(getTotalStatsPosts.pending, (state) => {
      state.isTotalStatsPostLoading = true;
      state.isTotalStatsPostSuccess = false;
      state.totalstatserror = null;
    });
    builder.addCase(getTotalStatsPosts.fulfilled, (state, action) => {
      state.isTotalStatsPostLoading = false;
      state.isTotalStatsPostSuccess = true;
      state.totalstatsposts = action.payload;
    });
    builder.addCase(getTotalStatsPosts.rejected, (state, action) => {
      state.isTotalStatsPostLoading = false;
      state.isTotalStatsPostSuccess = false;
      state.totalstatserror = action.error.message;
    });
    //====================================================================================

    //==================================[ /total likes count/ ]==========================
    builder.addCase(getTotalLikesCounts.pending, (state) => {
      state.isTotalTotalLikesCountsLoading = true;
      state.isTotalTotalLikesCountsSuccess = false;
      state.totallikescountserror = null;
    });
    builder.addCase(getTotalLikesCounts.fulfilled, (state, action) => {
      state.isTotalTotalLikesCountsLoading = false;
      state.isTotalTotalLikesCountsSuccess = true;
      state.totallikescounts = action.payload;
    });
    builder.addCase(getTotalLikesCounts.rejected, (state, action) => {
      state.isTotalTotalLikesCountsLoading = false;
      state.isTotalTotalLikesCountsSuccess = false;
      state.totallikescountserror = action.error.message;
    });
    //====================================================================================

    //total report
    builder.addCase(getRPTTotalStatsPosts.fulfilled, (state, action) => {
      state.rpttotalstatsposts = action.payload;
      state.isRPTTotalStatsPostFail = false;
      state.isRPTTotalStatsPostSuccess = true;
    });

    builder.addCase(getRPTTotalStatsPosts.rejected, (state, action) => {
      state.rpttotalstatsposts = action.payload.rpttotalstatserror || null;
      state.isRPTTotalStatsPostFail = true;
      state.isRPTTotalStatsPostSuccess = false;
    });

    //==================================[ /total Query count/ ]==========================
    builder.addCase(getTotalStatsQueryPosts.pending, (state) => {
      state.isTotalStatsQueryPostLoading = true;
      state.isTotalStatsQueryPostSuccess = false;
      state.totalstatsQueryerror = null;
    });
    builder.addCase(getTotalStatsQueryPosts.fulfilled, (state, action) => {
      state.isTotalStatsQueryPostLoading = false;
      state.isTotalStatsQueryPostSuccess = true;
      state.totalstatsQueryposts = action.payload;
    });
    builder.addCase(getTotalStatsQueryPosts.rejected, (state, action) => {
      state.isTotalStatsQueryPostLoading = false;
      state.isTotalStatsQueryPostSuccess = false;
      state.totalstatsQueryerror = action.error.message;
    });
    //====================================================================================

    //facebook
    builder.addCase(getStatsFBPosts.fulfilled, (state, action) => {
      state.statsFBposts = action.payload;
      state.isStatsFBPostFail = false;
      state.isStatsFBPostSuccess = true;
      state.fbpostsLoading = false;
    });

    builder.addCase(getStatsFBPosts.rejected, (state, action) => {
      state.statsFBposts = action.payload.statserror || null;
      state.isStatsFBPostFail = true;
      state.isStatsFBPostSuccess = false;
      state.fbpostsLoading = false;
    });

    //twitter
    builder.addCase(getStatsTWPosts.fulfilled, (state, action) => {
      state.statsTWposts = action.payload;
      state.isStatsTWPostFail = false;
      state.isStatsTWPostSuccess = true;
      state.twpostsLoading = false;
    });

    builder.addCase(getStatsTWPosts.rejected, (state, action) => {
      state.statsTWposts = action.payload.statTWserror || null;
      state.isStatsTWPostFail = true;
      state.isStatsTWPostSuccess = false;
      state.twpostsLoading = false;
    });

    //news
    builder.addCase(getStatsNWPosts.fulfilled, (state, action) => {
      state.statsNWposts = action.payload;
      state.isStatsNWPostFail = false;
      state.isStatsNWPostSuccess = true;
      state.nwpostsLoading = false;
    });

    builder.addCase(getStatsNWPosts.rejected, (state, action) => {
      state.statsNWposts = action.payload.statNWserror || null;
      state.isStatsNWPostFail = true;
      state.isStatsNWPostSuccess = false;
      state.nwpostsLoading = true;
    });

    //instagram
    builder.addCase(getStatsIGPosts.fulfilled, (state, action) => {
      state.statsIGposts = action.payload;
      state.isStatsIGPostFail = false;
      state.isStatsIGPostSuccess = true;
      state.igpostsLoading = false;
    });

    builder.addCase(getStatsIGPosts.rejected, (state, action) => {
      state.statsIGposts = action.payload.statIGserror || null;
      state.isStatsIGPostFail = true;
      state.isStatsIGPostSuccess = false;
      state.igpostsLoading = true;
    });

    //==================================[ /stats/ ]=======================================
    builder.addCase(getStatsPosts.pending, (state) => {
      state.isStatsPostLoading = true;
      state.isStatsPostSuccess = false;
      state.statserror = null;
    });
    builder.addCase(getStatsPosts.fulfilled, (state, action) => {
      state.isStatsPostLoading = false;
      state.isStatsPostSuccess = true;
      state.statsposts = action.payload;
    });
    builder.addCase(getStatsPosts.rejected, (state, action) => {
      state.isStatsPostLoading = false;
      state.isStatsPostSuccess = false;
      state.statserror = action.error.message;
    });
    //====================================================================================

    //report
    builder.addCase(getRPTStatsPosts.fulfilled, (state, action) => {
      state.rptstatsposts = action.payload;
      state.isRPTStatsPostFail = false;
      state.isRPTStatsPostSuccess = true;
    });

    builder.addCase(getRPTStatsPosts.rejected, (state, action) => {
      state.rptstatsposts = action.payload.rptstatserror || null;
      state.isRPTStatsPostFail = true;
      state.isRPTStatsPostSuccess = false;
    });

    //report fb
    builder.addCase(getRPTStatsFBPosts.fulfilled, (state, action) => {
      state.rptstatsFBposts = action.payload;
      state.isRPTStatsFBPostFail = false;
      state.isRPTStatsFBPostSuccess = true;
    });

    builder.addCase(getRPTStatsFBPosts.rejected, (state, action) => {
      state.rptstatsFBposts = action.payload.rptstatserror || null;
      state.isRPTStatsFBPostFail = true;
      state.isRPTStatsFBPostSuccess = false;
    });

    //report tw
    builder.addCase(getRPTStatsTWPosts.fulfilled, (state, action) => {
      state.rptstatsTWposts = action.payload;
      state.isRPTStatsTWPostFail = false;
      state.isRPTStatsTWPostSuccess = true;
    });

    builder.addCase(getRPTStatsTWPosts.rejected, (state, action) => {
      state.rptstatsTWposts = action.payload.rptstatserror || null;
      state.isRPTStatsTWPostFail = true;
      state.isRPTStatsTWPostSuccess = false;
    });

    //report nw
    builder.addCase(getRPTStatsNWPosts.fulfilled, (state, action) => {
      state.rptstatsNWposts = action.payload;
      state.isRPTStatsNWPostFail = false;
      state.isRPTStatsNWPostSuccess = true;
    });

    builder.addCase(getRPTStatsNWPosts.rejected, (state, action) => {
      state.rptstatsNWposts = action.payload.rptstatserror || null;
      state.isRPTStatsNWPostFail = true;
      state.isRPTStatsNWPostSuccess = false;
    });

    //report ig
    builder.addCase(getRPTStatsIGPosts.fulfilled, (state, action) => {
      state.rptstatsIGposts = action.payload;
      state.isRPTStatsIGPostFail = false;
      state.isRPTStatsIGPostSuccess = true;
    });

    builder.addCase(getRPTStatsIGPosts.rejected, (state, action) => {
      state.rptstatsIGposts = action.payload.rptstatserror || null;
      state.isRPTStatsIGPostFail = true;
      state.isRPTStatsIGPostSuccess = false;
    });

    //report
    builder.addCase(getRPTPosts.fulfilled, (state, action) => {
      state.rptposts = action.payload;
      state.isRPTPostFail = false;
      state.isRPTPostSuccess = true;
    });

    builder.addCase(getRPTPosts.rejected, (state, action) => {
      state.rpterror = action.payload.rpterror || null;
      state.isRPTPostFail = true;
      state.isRPTPostSuccess = false;
    });

    //==================================[ /getFBPosts/ ]=================================
    builder.addCase(getFBPosts.pending, (state) => {
      state.isFBPostLoading = true;
      state.isFBPostSuccess = false;
      state.fberror = null;
    });
    builder.addCase(getFBPosts.fulfilled, (state, action) => {
      state.isFBPostLoading = false;
      state.isFBPostSuccess = true;
      state.fbposts = action.payload;
    });
    builder.addCase(getFBPosts.rejected, (state, action) => {
      state.isFBPostLoading = false;
      state.isFBPostSuccess = false;
      state.fberror = action.error.message;
    });
    //====================================================================================

    //==================================[ /getTWPosts/ ]=================================
    builder.addCase(getTWPosts.pending, (state) => {
      state.isTWPostLoading = true;
      state.isTWPostSuccess = false;
      state.twerror = null;
    });
    builder.addCase(getTWPosts.fulfilled, (state, action) => {
      state.isTWPostLoading = false;
      state.isTWPostSuccess = true;
      state.twposts = action.payload;
    });
    builder.addCase(getTWPosts.rejected, (state, action) => {
      state.isTWPostLoading = false;
      state.isTWPostSuccess = false;
      state.twerror = action.error.message;
    });
    //====================================================================================

    //==================================[ /getNWPosts/ ]=================================
    builder.addCase(getNWPosts.pending, (state) => {
      state.isNWPostLoading = true;
      state.isNWPostSuccess = false;
      state.nwerror = null;
    });
    builder.addCase(getNWPosts.fulfilled, (state, action) => {
      state.isNWPostLoading = false;
      state.isNWPostSuccess = true;
      state.nwposts = action.payload;
    });
    builder.addCase(getNWPosts.rejected, (state, action) => {
      state.isNWPostLoading = false;
      state.isNWPostSuccess = false;
      state.nwerror = action.error.message;
    });
    //====================================================================================

    //==================================[ /getIGPosts/ ]=================================
    builder.addCase(getIGPosts.pending, (state) => {
      state.isIGPostLoading = true;
      state.isIGPostSuccess = false;
      state.igerror = null;
    });
    builder.addCase(getIGPosts.fulfilled, (state, action) => {
      state.isIGPostLoading = false;
      state.isIGPostSuccess = true;
      state.igposts = action.payload;
    });
    builder.addCase(getIGPosts.rejected, (state, action) => {
      state.isIGPostLoading = false;
      state.isIGPostSuccess = false;
      state.igerror = action.error.message;
    });
    //====================================================================================

    builder.addCase(addNewPost.fulfilled, (state, action) => {
      state.posts.push(action.payload);
      state.isPostAdd = true;
      state.isPostAddFail = false;
    });

    builder.addCase(addNewPost.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isPostAdd = false;
      state.isPostAddFail = true;
    });

    builder.addCase(updatePost.fulfilled, (state, action) => {
      if (action.payload && action.payload._id) {
        state.posts = (state.posts || []).map((post) =>
          post._id.toString() === action.payload._id.toString()
            ? { ...post, ...action.payload }
            : post
        );
      }
      state.isPostUpdate = true;
      state.isPostUpdateFail = false;
    });

    builder.addCase(updatePost.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isPostUpdate = false;
      state.isPostUpdateFail = true;
    });

    builder.addCase(deletePost.fulfilled, (state, action) => {
      const deletedId = (action.payload._id || action.payload.post || '').toString();
      const notDeleted = (arr) => (arr || []).filter(p => p._id.toString() !== deletedId);
      state.posts = notDeleted(state.posts);
      state.fbposts = notDeleted(state.fbposts);
      state.twposts = notDeleted(state.twposts);
      state.nwposts = notDeleted(state.nwposts);
      state.igposts = notDeleted(state.igposts);
      state.isPostDelete = true;
      state.isPostDeleteFail = false;
    });

    builder.addCase(deletePost.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isPostDelete = false;
      state.isPostDeleteFail = true;
    });

    //==================================[ /monthly-trend/ ]============================
    builder.addCase(getMonthlyTrend.fulfilled, (state, action) => {
      state.monthlyTrend = action.payload;
    });

    //==================================[ /wordcloud/ ]=================================
    builder.addCase(getWordCloud.pending, (state) => {
      state.isWordCloudLoading = true;
      state.isWordCloudSuccess = false;
      state.wordclouderror = null;
    });
    builder.addCase(getWordCloud.fulfilled, (state, action) => {
      state.isWordCloudLoading = false;
      state.isWordCloudSuccess = true;
      state.wordcloud = action.payload;
    });
    builder.addCase(getWordCloud.rejected, (state, action) => {
      state.isWordCloudLoading = false;
      state.isWordCloudSuccess = false;
      state.wordclouderror = action.error.message;
    });
  },
});

export default postSlice.reducer;
